import { render, staticRenderFns } from "./NotRelevantReviewModal.vue?vue&type=template&id=414cc656&scoped=true&"
import script from "./NotRelevantReviewModal.vue?vue&type=script&lang=js&"
export * from "./NotRelevantReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./NotRelevantReviewModal.vue?vue&type=style&index=0&id=414cc656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414cc656",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VIcon,VRow,VTextarea})
